import { render, staticRenderFns } from "./Favorited.vue?vue&type=template&id=1e1e7473&scoped=true"
import script from "./Favorited.vue?vue&type=script&lang=js"
export * from "./Favorited.vue?vue&type=script&lang=js"
import style0 from "./Favorited.vue?vue&type=style&index=0&id=1e1e7473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1e7473",
  null
  
)

export default component.exports